import { clientAttachmentService } from '../../helpers/services/clientAttachment.service'
import { sharedHelper } from '@/utils'

export const state = {
  list: [],
  status: { list: true, save: true },
}

export const CLIENT_ATTACHMENT_MODULE = 'clientAttachment'

export const GET_ATTACHMENTS = 'getAttachments'
export const UPLOAD_ATTACHMENT = 'uploadAttachment'
export const DELETE_ATTACHMENT = 'deleteAttachment'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'

export const actions = {
  [GET_ATTACHMENTS]({ commit }, { debtorCode }) {
    commit(REQUESTING, 'list')
    return clientAttachmentService.listAttachments(debtorCode).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [UPLOAD_ATTACHMENT]({ commit, dispatch }, { debtorCode, file, description }) {
    commit(REQUESTING, 'save')
    return clientAttachmentService.uploadAttachment(debtorCode, file, description).then(() => {
      commit(SUCCESS); dispatch(GET_ATTACHMENTS, { debtorCode }); return true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return false
    })
  },
  [DELETE_ATTACHMENT]({ commit, dispatch }, { debtorCode, uuid }) {
    commit(REQUESTING, 'save')
    return clientAttachmentService.deleteAttachment(debtorCode, uuid).then(() => {
      commit(SUCCESS); dispatch(GET_ATTACHMENTS, { debtorCode }); return true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return false
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    state.list = data?.data || []
  },
  [FAILURE](state) { state.status = { list: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, save: true } },
}
